<template>
  <DialogFull
    :data="dialogSettings"
    v-if="dialogSettings.dialog"
    @close="close"
  >
    <template v-slot:dialog.body>
      <div class="container mt-10">
        <h2 class="mb-8">{{ dialogSettings.title }}</h2>
        <PublishingScheduleForm
          ref="publishingScheduleForm"
          :publishingScheduleTemplate="publishingScheduleTemplate"
          :isUpdate="isUpdate"
          @onSubmit="saveTemplate"
        />
      </div>
    </template>
    <template v-slot:dialog.action>
      <PrimaryButton @click.native="validateForm" :loading="isSaving">
        {{ buttonLabel }}
      </PrimaryButton>
    </template>
  </DialogFull>
</template>

<script>
import DialogFull from "@/components/common/DialogFull";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { createNamespacedHelpers } from "vuex";
import { ORGANISATION_SCHEDULES_NAMESPACE } from "@/store/modules/organisations/organisation-schedules";
import {
  CREATE_PUBLISHING_SCHEDULE,
  UPDATE_PUBLISHING_SCHEDULE,
  FETCH_PUBLISHING_SCHEDULE_TEMPLATES,
  EDIT_TIER,
  ADD_TIER
} from "@/store/modules/organisations/organisation-schedules/actions";
import PublishingScheduleForm from "@/views/settings/components/publishing-schedule-templates/components/PublishingScheduleForm";
import { filter, map } from "lodash";

const { mapActions } = createNamespacedHelpers(
  ORGANISATION_SCHEDULES_NAMESPACE
);
export default {
  props: {
    isOpen: Boolean,
    isUpdate: Boolean,
    publishingScheduleTemplate: Object
  },
  components: {
    PrimaryButton,
    DialogFull,
    PublishingScheduleForm
  },
  data() {
    return {
      isSaving: false
    };
  },
  computed: {
    dialogSettings() {
      return {
        dialog: this.isOpen,
        title: `${this.isUpdate ? "Edit" : "New"} Publishing Schedule`
      };
    },
    buttonLabel() {
      return this.isUpdate ? "Save Changes" : "Create Publishing Schedule";
    }
  },
  methods: {
    ...mapActions({
      create: CREATE_PUBLISHING_SCHEDULE,
      update: UPDATE_PUBLISHING_SCHEDULE,
      fetchSchedules: FETCH_PUBLISHING_SCHEDULE_TEMPLATES,
      updateTier: EDIT_TIER,
      addTier: ADD_TIER
    }),
    validateForm() {
      this.$refs.publishingScheduleForm.validateForm();
    },
    async saveTemplate({ publishingScheduleTemplate, tiers }) {
      this.isSaving = true;
      this.isUpdate
        ? await this.updateSchedule({ publishingScheduleTemplate, tiers })
        : await this.createSchedule({ publishingScheduleTemplate, tiers });
      this.isSaving = false;
      this.close();
    },
    async createSchedule({ publishingScheduleTemplate, tiers }) {
      const publishing_schedule_id = await this.create(
        publishingScheduleTemplate
      );
      await this.addTiers({ tiers, publishing_schedule_id });
      this.fetchSchedules();
    },
    async updateSchedule({ publishingScheduleTemplate, tiers }) {
      const publishing_schedule_id = publishingScheduleTemplate.id;
      const tiersToBeAdded = filter(tiers, tier => !tier.id);
      const tiersToBeUpdated = filter(tiers, tier => tier.id);
      await this.addTiers({ tiers: tiersToBeAdded, publishing_schedule_id });
      await this.updateTiers(tiersToBeUpdated);
      await this.update({
        name: publishingScheduleTemplate.name,
        id: publishing_schedule_id
      });
      this.fetchSchedules();
    },
    async addTiers({ tiers, publishing_schedule_id }) {
      await Promise.all(
        map(tiers, async tier => {
          await this.addTier({
            ...tier,
            publishing_schedule_id
          });
        })
      );
    },
    async updateTiers(tiers) {
      await Promise.all(
        map(tiers, async tier => {
          await this.updateTier({
            id: tier.id,
            editedTier: tier
          });
        })
      );
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss"></style>
